import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

/**
 * React Router keeps the previous scroll offset across client-side
 * navigations, so a link followed from halfway down a page opens the next
 * one already scrolled — with its heading hidden behind the sticky nav.
 * Reset on push/replace, but leave back/forward to the browser so returning
 * to a page lands where the visitor left it.
 * @author Nelson
 */
const ScrollToTop = () => {
    const { pathname } = useLocation();
    const navigationType = useNavigationType();

    useEffect(() => {
        if (navigationType !== 'POP') {
            window.scrollTo(0, 0);
        }
    }, [pathname, navigationType]);

    return null;
};

export default ScrollToTop;
